import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { BreadcrumbElement } from 'src/types/commonTypes';

interface BreadcrumbState {
    items: BreadcrumbElement[];
}

const initialState: BreadcrumbState = {
    items: [{ label: 'Home', path: '/' }],
};

const breadcrumbSlice = createSlice({
    name: 'breadcrumb',
    initialState,
    reducers: {
        setBreadcrumb(state, action: PayloadAction<{ label: string; path: string }[]>) {
            state.items = action.payload;
        },
        addBreadcrumb(state, action: PayloadAction<{ label: string; path: string }>) {
            state.items.push(action.payload);
        },
        resetToBreadcrumb(state, action: PayloadAction<string>) {
            const index = state.items.findIndex((item) => item.path === action.payload);
            if (index !== -1) {
                state.items = state.items.slice(0, index + 1);
            }
        },
    },
});

export const { setBreadcrumb, addBreadcrumb, resetToBreadcrumb } = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer;
